<template>
<div>
  <div v-if="isLoading">
    <v-progress-linear
      indeterminate
      color="primary"
      ></v-progress-linear>
  </div>
  <v-container fluid>
      <v-card elevation="0" class="mb-3">
          <v-card-title>
            Articles authored by {{guestWriterName}}
          </v-card-title>
          <v-divider/>
      </v-card>
    <v-row>
        <v-col sm="12" md="6">
          <search-bar
                v-model="query.search"
                v-on:clear="clearSearch"
                v-on:request-search="onRequestSearch"
            />
        </v-col>
        <v-col sm="6" md="6">
            <sort-bar
                v-model="query.sort"
                v-bind:items="sortItems"
                v-on:request-sort="onRequestSort"
            />
        </v-col>

    </v-row>
    </v-container>
    <v-pagination
      v-if="this.pagination != undefined && this.pagination.totalItems > 0"
      v-model="pagination.currentPage"
      v-bind:length="pagination.pageCount"
      circle
      v-on:input = "onRequestPageChange"
    ></v-pagination>
    <div v-if="!isLoading && this.articles !== null">
      <v-row class="ma-1">
        <v-col
          v-if="this.articles.length<=0"
        >
          <v-banner
            single-line
            class="text-h6"
          >
            No records
          </v-banner>
        </v-col>
        <v-col
          sm="12"
          md="6"
          v-for="item in articles"
          :key="item.id"
          class="d-flex child-flex"
        >
          <article-card :showPriorityField="false" :data="item" @delete_success="articleDeletedCallback"></article-card>
        </v-col>
      </v-row>
    </div>
 </div>
</template>

<script>
// import snackbar from '@/utils/snackbar'
import guestWriterApi from '@/api/gwApi'
export default {
  components: {
    'search-bar': () => import('@/components/SearchBar'),
    'sort-bar': () => import('@/components/SortBar'),
    'article-card': () => import('@/components/ArticleCard')

  },

  mounted () {
    this.fetchArticle()
  },

  data: function () {
    return {
      isLoading: false,
      articles: null,
      guestWriterName: null,
      query: {
        id: null,
        search: null,
        sort: null,
        page: 1
      },
      pagination: {
        currentPage: 1,
        pageItemFrom: 0,
        pageItemTo: 0,
        totalItems: 0,
        pageCount: 0
      },
      sortItems: [
        { text: 'Newest first', value: 'created_at:desc' },
        { text: 'Oldest first', value: 'created_at:asc' }
      ]
    }
  },
  methods: {
    articleDeletedCallback () {
      this.fetchArticle()
    },
    async fetchArticle () {
      this.query.id = this.$route.params.id
      this.isLoading = true
      try {
        const response = await guestWriterApi.getGuestWritersArticle(this.query)
        if (response.data !== undefined) {
          this.articles = response.data.data
          // add guest writer name to header
          if (Array.isArray(this.articles) && this.articles.length > 0) {
            const ar1 = this.articles[0]
            if (ar1.guest_writer !== undefined && Array.isArray(ar1.guest_writer)) {
              const gw = ar1.guest_writer[0]
              this.guestWriterName = gw.name
            }
          } else {
            // try getting guest writer from local storage get from local storage
            if (window.Vanglaini !== undefined && window.Vanglaini.gwName !== undefined) {
              this.guestWriterName = window.Vanglaini.gwName
            }
          }

          this.parsePaginationData(response.data)
        }
      } finally {
        this.isLoading = false
      }
    },
    onRequestSort () {
      this.fetchArticle()
    },
    onRequestSearch () {
      this.fetchArticle()
    },
    clearSearch () {
      this.query.search = null
      this.fetchArticle()
    },
    onRequestPageChange (pageNo) {
      this.query.page = pageNo
      this.fetchArticle()
    },
    parsePaginationData (pagination) {
      this.pagination.currentPage = pagination.current_page
      this.pagination.totalItems = pagination.total
      this.pagination.pageItemFrom = pagination.from
      this.pagination.pageItemTo = pagination.to
      this.pagination.pageCount = pagination.last_page
    }

  }
}
</script>
